// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-management {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 1rem;
  z-index: 2;
}
.shop-management .shop {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 0.3rem 0rem 0.3rem 0.1rem;
  width: 20%;
}
.shop-management .shop > img {
  width: 1.6rem;
  height: 1.6rem;
}
.shop-management .shop__details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.shop-management .shop__details__name {
  font-size: 0.9rem;
  color: #4F4BFF;
}
.shop-management .shop__details__address {
  font-size: 0.7rem;
  color: #828282;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shop-management__choose-plan {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 20px 66px;
  gap: 1vw;
}
.shop-management__choose-plan__title {
  font-weight: bold;
  font-size: 24px;
}
.shop-management__choose-plan__plans {
  display: flex;
  flex-direction: row;
  gap: 2vw;
}
.shop-management__selectors {
  height: 5%;
}
.shop-management__chart {
  height: 25%;
}
.shop-management__preview-table {
  height: 70vh;
}
.shop-management__main-counter {
  font-size: 1.25rem;
  display: flex;
  gap: 1.5vw;
  margin-top: 2vh;
}
.shop-management__main-counter__label {
  font-weight: bold;
  color: black;
}
.shop-management__main-counter__value {
  color: #7D7D7D;
  font-weight: 500;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/shop-management/shop-management.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,UAAA;AACR;AAAQ;EACI,aAAA;EACA,cAAA;AAEZ;AAAQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAEZ;AADY;EACI,iBAAA;EACA,cAAA;AAGhB;AADY;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAGhB;AACI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AACR;AAAQ;EACI,iBAAA;EACA,eAAA;AAEZ;AAIQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAFZ;AAMI;EACI,UAAA;AAJR;AAMI;EACI,WAAA;AAJR;AAMI;EACI,YAAA;AAJR;AAOI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AALR;AAOQ;EACI,iBAAA;EACA,YAAA;AALZ;AAOQ;EACI,cAAA;EACA,gBAAA;AALZ;;AAUA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AAPJ","sourcesContent":[".shop-management {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 1rem;\n    z-index: 2;\n\n    .shop{\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 1rem;\n        padding: 0.3rem 0rem 0.3rem 0.1rem;\n        width: 20%;\n        >img{\n            width: 1.6rem;\n            height: 1.6rem;\n        }\n        &__details{\n            display: flex;\n            flex-direction: column;\n            gap: 0.25rem;\n            &__name{\n                font-size: 0.9rem;\n                color: #4F4BFF;\n            }\n            &__address{\n                font-size: 0.7rem;\n                color: #828282;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n        }\n    }\n    &__choose-plan{\n        position: absolute;\n        z-index: 3;\n        width: 100%;\n        height: 100%;\n        background-color: white;\n        display: flex;\n        flex-direction: column;\n        padding: 20px 66px;\n        gap: 1vw;\n        &__title{\n            font-weight: bold;\n            font-size: 24px;\n        }\n\n        &__shop-preview{\n\n        }\n        &__plans{\n            display: flex;\n            flex-direction: row;\n            gap: 2vw;\n        }\n\n    }\n    &__selectors{\n        height: 5%;\n    }\n    &__chart{\n        height: 25%;\n    }\n    &__preview-table{\n        height: 70vh;\n    }\n\n    &__main-counter{\n        font-size: 1.25rem;\n        display: flex;\n        gap: 1.5vw;\n        margin-top: 2vh;\n        \n        &__label{\n            font-weight: bold;\n            color: black;\n        }\n        &__value{\n            color: #7D7D7D;\n            font-weight: 500;\n        }\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
